module.exports = __webpack_public_path__ + "img/Proliferation-BRCA_10X_WTA.31ede1ff.png";